import { DateTime } from 'luxon';

export const buildDateString = (tempDate: number | string | Date) => {
  const date = new Date(tempDate);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const dateString = new Date(`${year}-${month}-${day}`);
  return dateString;
};

export const formatBookingDate = ({
  date,
  timezone,
  language,
}: {
  date: string;
  timezone?: string;
  language: string;
}) =>
  DateTime.fromISO(date)
    .setZone(timezone)
    .setLocale(language)
    .toLocaleString(DateTime.DATE_FULL);
